import * as React from "react";

export type BadgeVariant =
  | "muted"
  | "success"
  | "warning"
  | "info"
  | "destructive";

export type BadgeShape = "pill" | "square";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  /** `pill` (default): rounded-full. `square`: rounded (small corner). */
  shape?: BadgeShape;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  muted: "bg-muted text-muted-foreground",
  success: "bg-success-soft text-success-soft-foreground",
  warning: "bg-warning-soft text-warning-soft-foreground",
  info: "bg-info-soft text-info-soft-foreground",
  destructive: "bg-destructive-soft text-destructive-soft-foreground",
};

const SHAPE_CLASSES: Record<BadgeShape, string> = {
  pill: "rounded-full",
  square: "rounded",
};

const BASE = "inline-flex items-center px-2 py-0.5 text-xs font-medium";

export function Badge({
  variant = "muted",
  shape = "pill",
  className,
  ...rest
}: BadgeProps) {
  const classes = [BASE, SHAPE_CLASSES[shape], VARIANT_CLASSES[variant], className]
    .filter(Boolean)
    .join(" ");
  return <span className={classes} {...rest} />;
}
